module.exports = __webpack_public_path__ + "img/logo-heppi@2x.46a4f163.png";